// eslint-disable-next-line import/prefer-default-export
export var TRUNCATED_WIDTH = 350;